import React from 'react'
import Authorization from '../components/Authorization'

export const Login = () => {
  return (
    <Authorization method="Login"/>
  )
}

export const Register = () => {
  return (
    <Authorization method="Register"/>
  )
}
